export default __webpack_public_path__ + "static/bg_top_service_04-c1f8d48d8694938ea6e81025b44971e4.mp4";